import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { UNMUTE } from './types';

export const playerUnmuteAction = actionCreator(UNMUTE);

export const playerUnmuteThunkAction = () => (dispatch) => dispatch(playerUnmuteAction());
